var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading && _vm.count)?_c('span',{staticClass:"my-space-hero-chip",attrs:{"title":"Recordatorios vencidos y programados para hoy"},on:{"click":_vm.goReminders}},[_c('AppIcon',{attrs:{"name":"alarm"}}),_vm._v(_vm._s(_vm.count)+" "+_vm._s(_vm.count === 1 ? 'recordatorio pendiente' : 'recordatorios pendientes'))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }